import { render, staticRenderFns } from "./JSONPreview.vue?vue&type=template&id=25480e4d&scoped=true"
import script from "./JSONPreview.vue?vue&type=script&lang=js"
export * from "./JSONPreview.vue?vue&type=script&lang=js"
import style0 from "./JSONPreview.vue?vue&type=style&index=0&id=25480e4d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25480e4d",
  null
  
)

export default component.exports